export enum ColorMode {
  LIGHT = 'light',
  DARK = 'dark',
  CUSTOM = 'custom'
}
